import { useState, useEffect } from "react";
import { Input } from "../../../components/Input/Input";
import Select from "../../../components/Select/Select";
import logo from "../../../assets/recode_pro-logo-1.svg";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import styles from "../../Sgr/Sgr.module.scss";
// import styles from "./Recodepro.module.scss";
import { AlignCenter } from "../../../components/Box/Box";
import { ContainedBtn, OutlineBtn } from "../../../components/ButtonTypes/Button";
import { useContext } from "react";
import { AuthContext } from "../../../services/Auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight, faFile, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { swalTheme, Toast } from "../../../services/Swal";

//TABLE KEYBOARD ICONS: ☑, ☐, ☒

function RecodeproValidaDoc() {
  const { user } = useContext(AuthContext);
  const [classificados, setClassificados] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [filtro, setFiltro] = useState("");
  // const [flip, setFlip] = useState(true);
  const [loading, setLoading] = useState(true);
  const paginationSize = 25;
  const paginationInitial = (currentPage - 1) * paginationSize;
  const paginationTotal = Math.ceil(
    classificados.filter(
      (f) =>
        f.nome.toLowerCase().includes(filtro.toLowerCase()) ||
        f.email.toLowerCase().includes(filtro.toLowerCase())
    ).length / paginationSize
  );

  const currentYear = new Date().getFullYear();
  const [anoProcessoSeletivo, setAnoProcessoSeletivo] = useState(new Date().getFullYear());

  const [tipoDocumentos, setTipoDocumentos] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND}/api/RecodePro/GetListaDocumentosStatus`, {
      method: "GET",
      //headers: { Authorization: user.token },
    })
      .then(response => response.json())
      .then(result => {
        console.warn(result);
        setTipoDocumentos(result)
      })
      .catch(error => console.log('error', error));
  }, [])

  useEffect(() => {
    setLoading(true);
    fetch(
      `${process.env.REACT_APP_BACKEND}/api/RecodePro/ListaClassificados?AnoProcessoSeletivo=${anoProcessoSeletivo}`,
      {
        method: "GET",
        contentType: "application/json",
        headers: {
          Authorization: user.token,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.warn(data);
        setClassificados(data);
      })
      .catch((error) => console.log("error", error))
      .finally(() => setLoading(false));
  }, [anoProcessoSeletivo, user.token]);

  async function getDocumento(documento, idEstudante) {
    await fetch(
      `${process.env.REACT_APP_BACKEND}/api/RecodePro/GetDocumento?Documento=${documento}&IdEstudante=${idEstudante}`,
      {
        method: "GET",
        contentType: "application/json",
        headers: {
          Authorization: user.token,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        //return console.log("erro split", data)
        //if (data.payload.split('.').pop() === "pdf") return window.open(data.payload, '_blank').focus();
        if (data.payload.split('.').pop() === "pdf") return Swal.fire({
          html: `<embed src="${data.payload}"  style="height: 80vh; width: 100%"  type="application/pdf" />`,
          // grow: "fullscreen",
          confirmButtonText: "Fechar",
          ...swalTheme
        })

        return Swal.fire({
          imageUrl: data.payload,
          // grow: "fullscreen",
          confirmButtonText: "Fechar",
          ...swalTheme
        })

      });
  }

  function onChangeDocumento(idEstudante, nomeDocumento, status) {

    const data = {
      idEstudante: idEstudante,
      nomeDocumento: nomeDocumento,
      status: status
    };

    fetch(`${process.env.REACT_APP_BACKEND}/api/RecodePro/AprovaDocumento`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
        Authorization: user.token,
      }
    })
      .then(response => response.text())
      // .then(result => console.log(result) )
      .catch(error => console.log('error', error));
  }

  async function existeDocumentoInvalidoOuPendente(classificado) {
    let classificadoRetorno = []
    await fetch(
      `${process.env.REACT_APP_BACKEND}/api/RecodePro/ListaClassificados?AnoProcessoSeletivo=${anoProcessoSeletivo}`,
      {
        method: "GET",
        contentType: "application/json",
        headers: {
          Authorization: user.token,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => classificadoRetorno = data)
      .catch((error) => console.log("error", error));

    const classificadoFiltrado = classificadoRetorno.filter(c => c.idestudante === classificado.idestudante)[0]

    const statusDocumentos = [];
    tipoDocumentos.map(doc =>
      statusDocumentos.push(classificadoFiltrado?.documentos[doc.toLowerCase()]?.status)
    )

    const tudoValido = statusDocumentos.some(status => {
      return status !== "Valido"
    })

    return tudoValido
  }

  function DocumentoControles({ classificado, documento, status = "Pendente" }) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <ContainedBtn
          disabled={!!!classificado?.documentos[documento.toLowerCase()]?.status}
          className={styles.button}
          onClick={() => {
            getDocumento(documento, classificado.idestudante)
          }}
        >
          <FontAwesomeIcon icon={faFile} />
        </ContainedBtn>

        <Select
          className={styles.select}
          disabled={!!!classificado?.documentos[documento.toLowerCase()]?.status}
          defaultLabel={false}
          defaultValue={status}
          onChange={(e) => {
            // console.log(classificado.idestudante, documento, e.target.value)
            onChangeDocumento(classificado.idestudante, documento, e.target.value)
          }}
        >
          <option value="Pendente" hidden> ❔ </option>
          <option value="Valido"> ✅ </option>
          <option value="Invalido"> ❌ </option>
          {/* <option value="Pendente" hidden> ⭕ Pendente </option>
          <option value="Valido"> ✅ Valido </option>
          <option value="Invalido"> ❌ Invalido </option> */}
        </Select>
      </div>
    )
  }

  async function enviarEmail(classificado) {
    const mensagem = {}
    const tudoValido = await existeDocumentoInvalidoOuPendente(classificado)

    if (tudoValido) {
      mensagem.icon = "warning"
      mensagem.text = "Digite abaixo a mensagem a ser inserida no meio do e-mail que será enviado ao usuário."
    } else {
      mensagem.icon = "info"
      mensagem.text = "Enviar e-mail confirmando que todos os documentos foram avaliados e validados com sucesso!"
    }

    Swal.fire({
      icon: mensagem.icon,
      title: 'Mensagem',
      text: mensagem.text,
      input: tudoValido ? 'textarea' : false,
      confirmButtonText: 'Enviar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      showLoaderOnConfirm: true,
      preConfirm: (m) => {
        return fetch(`${process.env.REACT_APP_BACKEND}/api/RecodePro/EnviaEmail`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: user.token,
            },
            body: JSON.stringify({
              idEstudante: classificado.idestudante,
              tipoEmail: tudoValido ? 'Recusa' : 'Valido',
              mensagem: m === true ? null : m
            })
          })
          .then(response => response.json())
          .catch(error => console.error(error))
      },
      allowOutsideClick: () => !Swal.isLoading(),
      backdrop: true,
      ...swalTheme,
    }).then((result) => {
      if (result.isConfirmed) Toast.fire({
        icon: result.value.success ? "info" : "error",
        title: "Email de Validação de documentos disparado!"
      })
    })
  }

  return (
    <>
      <AlignCenter>
        <img src={logo} className={styles.logo} alt="logo" />
      </AlignCenter>

      <h1>Validação de Documentação</h1>

      <Input
        className={styles.input}
        label="Ano do processo seletivo"
        type="number"
        value={anoProcessoSeletivo}
        onChange={(e) => {
          setAnoProcessoSeletivo(e.target.value);
          setCurrentPage(1);
        }}
        max={currentYear}
        disabled={loading}
      />

      <Input
        className={styles.input}
        label="Localizar"
        placeholder="Nome ou e-mail"
        type="search"
        value={filtro}
        onChange={(e) => {
          setFiltro(e.target.value);
          setCurrentPage(1);
        }}
      />

      <br />
      {loading ? (
        "Carregando"
      ) : (
        <>
          {(classificados.length === 0 && "Sem classificados para mostrar.") || (
            <>
              <div className={styles.containerTable}>
                <table className={styles.table}>
                  <tbody>
                    <tr>
                      <th className={styles.tableCell}>Nome</th>
                      <th className={styles.tableCell}>E-mail</th>
                      {tipoDocumentos.map(doc => <th className={styles.tableCell} key={doc}>{doc}</th>)}
                      <th className={styles.tableCell}>Mensagem</th>
                    </tr>

                    {classificados
                      .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'))
                      .filter(
                        (f) =>
                          f.nome.toLowerCase().includes(filtro.toLowerCase()) ||
                          f.email.toLowerCase().includes(filtro.toLowerCase())
                      )
                      .slice(
                        paginationInitial,
                        paginationInitial + paginationSize
                      ).map((classificado) => (
                        <tr key={classificado.idestudante}>
                          <td className={styles.tableCell}>{classificado.nome}</td>
                          <td className={styles.tableCell}>{classificado.email}</td>
                          {tipoDocumentos.map(doc => <td className={styles.tableCell} key={doc}><DocumentoControles classificado={classificado} documento={doc} status={classificado?.documentos[doc.toLowerCase()]?.status} /></td>)}
                          <td className={styles.tableCell}>
                            <ContainedBtn
                              className={styles.button}
                              onClick={() => enviarEmail(classificado)}
                            >
                              <FontAwesomeIcon icon={faPaperPlane} />
                            </ContainedBtn>
                          </td>
                        </tr>
                      ))}

                  </tbody>
                </table>
              </div>

              <center>
                <OutlineBtn
                  className={styles.button}
                  disabled={parseInt(currentPage) === 1 ? true : false}
                  onClick={() => setCurrentPage((c) => parseInt(c) - 1)}
                >
                  <FontAwesomeIcon icon={faChevronLeft} />{" "}
                </OutlineBtn>
                (
                <input
                  label="Página"
                  type="number"
                  value={currentPage}
                  onChange={(e) => setCurrentPage(e.target.value)}
                  min={1}
                  max={paginationTotal}
                />{" "}
                / {paginationTotal})
                <OutlineBtn
                  className={styles.button}
                  disabled={parseInt(currentPage) === paginationTotal}
                  onClick={() => setCurrentPage((c) => parseInt(c) + 1)}
                >
                  <FontAwesomeIcon icon={faChevronRight} />{" "}
                </OutlineBtn>
              </center>
            </>
          )}
        </>
      )}
    </>
  );
}

export default RecodeproValidaDoc;